<script>
  /**
   * The signed-out page frame the login screen uses: theme toggle, glow
   * background, logo, a title and one elevated card for the content.
   */
  import { onMount } from 'svelte';
  import { Sun, Moon } from 'lucide-svelte';
  import { theme } from '../stores/theme.js';

  /** Heading shown above the card. */
  export let title = '';

  onMount(() => {
    theme.init();
  });
</script>

<div class="min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8 retro-grid transition-colors duration-300" style="background-color: var(--color-bg-dark);">
  <button
    on:click={() => theme.toggle()}
    class="absolute top-4 right-4 h-10 w-10 inline-flex items-center justify-center text-gray-400 hover:text-primary-500 transition-all duration-100 border-2 border-transparent hover:border-primary-500 z-20"
    title={$theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
  >
    {#if $theme === 'dark'}
      <Sun size={18} />
    {:else}
      <Moon size={18} />
    {/if}
  </button>

  <div class="absolute inset-0 overflow-hidden pointer-events-none">
    <div class="absolute top-1/4 left-1/4 w-96 h-96 rounded-full blur-3xl" style="background: rgba(255, 0, 255, 0.08);"></div>
    <div class="absolute bottom-1/4 right-1/4 w-96 h-96 rounded-full blur-3xl" style="background: rgba(0, 240, 255, 0.08);"></div>
  </div>

  <div class="relative z-10 sm:mx-auto sm:w-full sm:max-w-md fade-in">
    <div class="flex justify-center mb-6">
      <div class="relative scale-in">
        <div class="absolute inset-0 blur-2xl rounded-full" style="background: rgba(0, 240, 255, 0.2);"></div>
        <img class="relative h-16 w-auto drop-shadow-lg" src="/webdeploy-icon.png" alt="WEBDEPLOY" />
      </div>
    </div>
    <h1 class="text-center text-2xl font-bold text-gradient font-display tracking-wider">{title}</h1>
  </div>

  <div class="relative z-10 mt-8 sm:mx-auto sm:w-full sm:max-w-md slide-up">
    <div class="card-elevated p-8 space-y-6">
      <slot />
    </div>
  </div>
</div>
